import { EditGame } from "./components/EditGame";

export default EditGame;
